<app-header [label]="params.id ? 'Update University' : 'Add University'"></app-header>

<form [formGroup]="form" class="h-[calc(100vh-100px)] min-h-[500px] overflow-y-auto">
  <div class="py-2 grid grid-cols-1 gap-4">

    <!-- University Info -->
    <div class="bg-white border border-gray-300 shadow-sm flex flex-col p-4 rounded-lg gap-4">
      <!-- Row 1: Code (1/4) + Name (3/4) -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
        <app-text-input class="md:col-span-1" formControlName="code" [label]="'University Code'" [isRequired]="true">
        </app-text-input>
        <app-text-input class="md:col-span-3" formControlName="name" [label]="'University Name'" [isRequired]="true">
        </app-text-input>
      </div>
      <!-- Row 2: City (~half width) -->
      <div class="grid  grid-cols-1 md:grid-cols-2  gap-4">
        <app-select-input label="City" formControlName="city_id" [options]="ds.dropdown_list?.city_list">
        </app-select-input>
      </div>
      <!-- Row 3: Address (full width) -->
      <div class="grid grid-cols-12 gap-4">
        <!-- Address - full width (col-span-6) -->
        <app-text-input class=" col-span-12 md:col-span-9" formControlName="address" [label]="'Address'" [isRequired]="true">
        </app-text-input>
        <div class="hidden md:block md:col-span-3"> </div>
      </div>

      <!-- Row 4: Mobile + Email (50/50) -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <app-text-input type="number" formControlName="contact" [label]="'Mobile Number'">
        </app-text-input>
        <app-text-input type="email" formControlName="email" [label]="'Email ID'">
        </app-text-input>
      </div>
    </div>

    <!-- Access Controls -->
    <app-form-section label="Access Controls">
      <div class="col-span-3 flex justify-between flex-wrap">
        <app-radio formControlName="face_verification" label="Face Verification" [is_required]="true" layout="horizontal" [options]="enable_disable_options"></app-radio>
        <app-radio formControlName="aadhaar_verification" label="Aadhaar Verification" [is_required]="true" layout="horizontal" [options]="enable_disable_options"></app-radio>
        <app-radio formControlName="image_to_text" label="Image to Text" [is_required]="true" layout="horizontal" [options]="enable_disable_options"></app-radio>
        <app-radio formControlName="ai_proctoring" label="AI Proctoring" [is_required]="true" layout="horizontal" [options]="enable_disable_options"></app-radio>
        <app-radio formControlName="ai_evaluation" label="AI Evaluation" [is_required]="true" layout="horizontal" [options]="enable_disable_options"></app-radio>
        <app-radio formControlName="assessment_type" label="Assessment Type" [is_required]="true" layout="horizontal" [options]="assessment_type_options"></app-radio>
      </div>
    </app-form-section>

    <!-- Admin Configuration -->
    <app-form-section *ngIf="gs.access_scope.is_all" label="Admin Configuration" sub_label="(For Receipt Purpose)" description="Note: Please ensure the university admin has configured these settings before generating receipts.">
      <div class="col-span-3 flex justify-end items-center -mt-16 gap-3 mb-2">
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" formControlName="admin_config_required" class="sr-only peer" />
          <div class="w-12 h-6 bg-gray-300 rounded-full peer-checked:bg-primary after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:h-5 after:w-5 after:rounded-full after:shadow-md after:transition-all peer-checked:after:translate-x-6">
          </div>
        </label>
      </div>
      <div *ngIf="admin_config_required" class="col-span-3 flex gap-6">

        <!-- Left: Logo Upload -->
        <div class="flex flex-col items-center gap-3 w-[200px] flex-shrink-0">
          <app-file-uploader #logoUploader lebal="Logo" formControlName="logo_url" [accept]="'.jpg,.jpeg,.png'" [maxFileSize]="1" [uploaderVariant]="'photo-box'" [box_clickable]="false" [is_required]="admin_config_required" class="w-full">
          </app-file-uploader>
          <p class="text-[0.65rem] text-gray-400 text-center">(200x200px, PNG, Jpeg, JPG Up To 1MB).</p>
          <button type="button" (click)="logoUploader.triggerUpload()" class="w-full rounded-full border-2 border-[#3F41D1] text-[#3F41D1] font-semibold text-sm py-2 px-4 bg-white hover:bg-indigo-50 transition-colors">
            Upload University Logo
          </button>
        </div>

        <!-- Right: Config Fields -->
        <div class="flex-1 flex flex-col gap-4">
          <app-text-input formControlName="receipt_university_name" [label]="'University Name (For Receipt Purpose)'" [is_required]="admin_config_required">
          </app-text-input>
          <app-text-input formControlName="receipt_address" [label]="'Address'" [isRequired]="admin_config_required">
          </app-text-input>

          <!-- GST -->
          <div>
            <div class="flex items-center gap-2 mb-3">
              <span class="text-sm font-medium text-gray-900">GST required</span>
              <span class="text-xs text-gray-500 italic">Select if GST is required, if yes GSTIN Number is mandatory.</span>
            </div>
            <div class="flex items-center gap-6">
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="gst_required" value="yes" class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 checked:before:block before:hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" />
                <span class="text-sm font-medium text-gray-900">Yes</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="gst_required" value="no" class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 checked:before:block before:hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" />
                <span class="text-sm font-medium text-gray-900">No</span>
              </label>
              <app-text-input *ngIf="gst_required === 'yes'" formControlName="gstn" [label]="'GSTIN'" [isRequired]="true" custom_pattern_error_msg="Please enter a valid GSTIN" class="w-72">
              </app-text-input>
            </div>
          </div>

          <!-- Signatory + Designation -->
          <div class="grid grid-cols-2 gap-4">
            <app-text-input formControlName="signatory_name" [label]="'Authorized Signatory Name'" [isRequired]="admin_config_required">
            </app-text-input>
            <app-text-input formControlName="designation" [label]="'Designation'" [isRequired]="admin_config_required">
            </app-text-input>
          </div>

          <!-- Signature Upload -->
          <app-file-uploader formControlName="signature_url" [accept]="'.jpg,.jpeg,.png'" [maxFileSize]="1" lebal="Signature Image (Upload)" [is_required]="admin_config_required" sub_text="Supported: .Jpeg, .Jpg, .Png, Max: 1MB">
          </app-file-uploader>
        </div>

      </div>
    </app-form-section>

  </div>
</form>

<!-- Sticky Footer -->
<div class="flex justify-end items-center gap-3 p-4 sticky bottom-0 bg-white z-1 rounded-b-2xl shadow-lg">
  <app-button color="border-primary text-primary" label="Discard" type="button" (click)="gs.go_back()"></app-button>
  <app-button color="bg-[#3F41D1] text-white" [label]="params.id ? 'Update' : '+ Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
</div>